/* eslint-disable */
import configuration from '../../envConfig';
import { getInternalResource } from "../../shared/helper/requests";
import { AcaoArquivo } from 'shared/constantes/acaoArquivo';
import { Utf8ArrayToStr, dataURIToBlob, cdvMimeType } from "../../shared/helper/impressao";

export const platform = {
    name: "cordova",
    isWeb: false,
    isCordova: true,
    barraBrasilOffset: '0px'
}

export const reviewDialog = () => {
    cordova.plugins.AppReview.requestReview().catch(function() {
        return cordova.plugins.AppReview.openStoreScreen();
    });
}

export const openStoreScreen = () => {
    cordova.plugins.AppReview.openStoreScreen();
}

export const getPlatformName = () => {
    return window._deviceName;
}

export const checkGovBrInstalado = callback => {

    let scheme;
    if (device.platform === 'iOS') {
        scheme = configuration.meuGovBrSchemaIos;
    }
    else if (device.platform === 'Android') {
        scheme = configuration.meuGovBrSchemaAndroid;
    }

    appAvailability.check(
        scheme,
        () => callback(true),
        () => callback(false)
    );
}

export const openGovBr = callback => {

    let scheme;
    if (device.platform === 'iOS') {
        scheme = { uri: configuration.meuGovBrSchemaIos };
    }
    else if (device.platform === 'Android') {
        scheme = { packageName: configuration.meuGovBrSchemaAndroid };
    }

    window.plugins.launcher.launch(scheme,
        () => callback(true),
        () => callback(false)
    );
}

export const openMarketplace = callback => {

    let scheme;
    if (device.platform === 'iOS') {
        scheme = { uri: 'itms-apps://itunes.apple.com/app/id1506827551' };
    }
    else if (device.platform === 'Android') {
        scheme = { uri: 'market://details?id=br.gov.meugovbr' };
    }

    window.plugins.launcher.launch(scheme,
        () => callback(true),
        () => callback(false)
    );
}

const escolherAcaoAbrirPDF = (fileURL, mimeType, acaoArquivo) => {
    
    const acaoArquivoNumber = isNaN(acaoArquivo) ? AcaoArquivo.ABRIR : parseInt(acaoArquivo);

    if (acaoArquivoNumber === AcaoArquivo.COMPARTILHAR) {
        window.plugins.socialsharing.share(null, null, fileURL);
    } else if (acaoArquivoNumber === AcaoArquivo.ABRIR){
        cordova.plugins.fileOpener2.open(
            fileURL,
            mimeType,
            {
                error : e => {
                    alert('Erro ao abrir arquivo ' + fileURL + '.')
                }
            }
        );
    } else if (acaoArquivoNumber === AcaoArquivo.DOWNLOAD) {
        cordova.plugins.notification.local.schedule({
            title: fileURL.substring(fileURL.lastIndexOf('/') + 1),
            text: 'Download concluído', 
            smallIcon: 'res://ic_launcher',
			foreground: true,
            data: { fileURL: fileURL }
        });
    }
}

const getOutputFilePath = (acaoArquivo) => {
    
    const acaoArquivoNumber = isNaN(acaoArquivo) ? AcaoArquivo.ABRIR : parseInt(acaoArquivo);
    
    if (acaoArquivoNumber !== AcaoArquivo.DOWNLOAD) {
        return cordova.file.dataDirectory;
    }
    
    if (device.platform === 'iOS') {
        return cordova.file.documentsDirectory;
    } else {
        return cordova.file.externalRootDirectory + "Download/";
    }

}

export const criarDownloadPdfImpl = (data, fileName, acaoArquivo) => {
    try {
        var decodedString = Utf8ArrayToStr(new Uint8Array(data));
        var obj = JSON.parse(decodedString);
        if ('result' in obj) {
            return obj.result;
        }
        if ('mensagem' in obj) {
            return obj.mensagem;
        }
        if('message' in obj) {
            return obj.message;
        }
    } catch (e) {
        let outputDir = getOutputFilePath(acaoArquivo);
        window.resolveLocalFileSystemURL(outputDir, (dirEntry) => {
            if (acaoArquivo !== AcaoArquivo.DOWNLOAD) {
                writeFile(dirEntry, fileName, data, acaoArquivo);
            } else {
                verifyExistsWriteFile(dirEntry, fileName, data, acaoArquivo, 0); 
            }
        }, (error) => {
            alert('Erro ao resolver pasta ' + outputDir + '.')
        });
    }
};

const verifyExistsWriteFile = (dirEntry, fileName, data, acaoArquivo, index) => {
    
    let i = fileName.lastIndexOf('.');
    let fileNameWithIndex = index === 0 ? fileName : `${fileName.substring(0, i)} ${index}.${fileName.substring(i + 1)}`;

    dirEntry.getFile(fileNameWithIndex, { create: false }, () => {
        verifyExistsWriteFile(dirEntry, fileName, data, acaoArquivo, index + 1);
    }, () => {
        writeFile(dirEntry, fileNameWithIndex, data, acaoArquivo);
    });

}

const writeFile = (dirEntry, fileName, data, acaoArquivo) => {
    
    dirEntry.getFile(fileName, { create: true }, (entry) => {
        entry.createWriter((writer) => {
            writer.onwriteend = () => {
                escolherAcaoAbrirPDF(decodeURIComponent(entry.nativeURL), 'application/pdf', acaoArquivo);
            };
            writer.onerror = (error) => {
                if (error?.target?.error?.code === 2) {
                    alert('Permissão negada para salvar arquivo ' + fileNameWithIndex + '.')
                } else {
                    alert('Erro ao gravar arquivo ' + fileNameWithIndex + '.')
                }
            };
            let blob = new Blob([data], {
                type: "application/pdf"
            });
            writer.write(blob);
        });
    }, (error) => {
        alert('Erro ao criar arquivo ' + fileNameWithIndex + '.')
    });
    
}

export const downloadArquivosImpl = (data, fileName, acaoArquivo = AcaoArquivo.ABRIR) => {
    try {
    
        var outputDir = getOutputFilePath();

        var blob = dataURIToBlob("data:application/json;base64," + data);
        window.resolveLocalFileSystemURL(outputDir, function(dirEntry) {
                dirEntry.getFile(fileName, {create: true}, function(entry) {
                    entry.createWriter(function(writer) {
                        writer.onwrite = function(evt) {
                            let urlArray = evt.target.localURL.split(".");
                            let fileExt = urlArray[urlArray.length -1];
                            if(fileExt) fileExt = fileExt.toLowerCase();
                            escolherAcaoAbrirPDF(decodeURIComponent(entry.nativeURL), cdvMimeType(fileExt), acaoArquivo);
                        };
                        writer.write( blob );
                    }, function(error) {
                    });
                }, function(error){
                });
            },
            function(event){
            });
    } catch (e) {
        return false;
    }
};

const openBrowserTab = (url) => {
    try {
        cordova.plugins.browsertab.openUrl(
            url,
            () => {}, 
            (error) => { console.log(error); window.open(url, '_system'); }
        );
    } catch (error) {
        window.open(url, '_system');
    }
}

export const closeBrowserTab = () => {
    try {
        cordova.plugins.browsertab.close();
    } catch (error) {
        alert('Erro ao fechar página. Feche para voltar pro Meu INSS.');
    }
}

export const openLoginPage = () => {
    
    console.debug('Abrindo página de login');

    let urlLoginPrefix = configuration.urlLogin;
    let clientId = configuration.clientId;
    let nonce = Math.random() * 13;
    let state = Math.random() * 7;
    
    let scopes = "openid+phone+profile+govbr_confiabilidades_idtoken+poav1_createPoaAccessHistory_agent+poav1_retrievePowersOfAttorneyByAgentAccountIdAndGrantorAccountIdAndClientIdAndIsActive_agent";
    let responseType = "code";
    //let page = getUrlVars()['page']; // TODO Redirecionamento com parâmetro do app não está funcionando
    let page = undefined;
    let redirectUri = encodeURIComponent('meuinss://autorizar.html' + (page ? `?page=${page}` : ''));
    let loginUrl = `${urlLoginPrefix}authorize?response_type=${responseType}&client_id=${clientId}&scope=${scopes}&redirect_uri=${redirectUri}&nonce=${nonce}&state=${state}`;
   
    openBrowserTab(loginUrl);
    
    window.location.replace(configuration.baseUrl + '?auth#/login');
};

export const openLogoutUrl = () => {
    openBrowserTab(configuration.urlLogin + 'logout?post_logout_redirect_uri=meuinss://index.html');
}

export const openKbaPage = () => {
    
    console.debug('Abrindo página do KBA');
        
    var redirect_uri = encodeURIComponent('meuinss://kba.html');
    var prefixoUrlKba = configuration.kbaUrl;
    var sufixAccessToken = "?token=" + localStorage.getItem('ifs_auth');
    var sufixRedirect = "&uri_retorno="+ redirect_uri;
    
    openBrowserTab(prefixoUrlKba + sufixAccessToken + sufixRedirect);

}

export const showPdfLocal = (res, assetRes,fileName) =>{
    
    if(device.platform == "iOS"){
        window.open(assetRes, "janela", "toolbar=yes,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,closebuttoncaption=Fechar,toolbarposition=top,enableViewportScale=yes");
    } else {
        getInternalResource(res)
        .then(response => (criarDownloadPdfImpl(response.data, fileName)))
        .catch();
    }
}

export const oldServicesUrl = () => {
    return './v35/index.html#';
}

export const getDevicePlatform = () => {
    return device.platform;
}

export const getVersion = async () => {
    return cordova.getAppVersion.getVersionNumber();
}

export const update = (acaoFalha) => {
    cordova.plugins.market.open(device.platform == 'iOS' ? 'id1243048358' : 'br.gov.dataprev.meuinss', {
        error: function() {
            alert('Erro ao acessar aplicativo na loja.')
            if (acaoFalha) {
                acaoFalha();
            }
        }
    })
}  

export const exit = () => {
    navigator.app.exitApp();
}

export const requestCameraPermission = (sucess, error) => {
    // TODO Falta verificar iOS
    if (device.platform === 'Android') {
        let permissions = cordova.plugins.permissions;
        permissions.checkPermission(permissions.CAMERA, status => {
            if (status.hasPermission) {
                sucess();
            } else {
                permissions.requestPermissions([permissions.CAMERA], statusRequest => {
                    if( statusRequest.hasPermission ) {
                        sucess();
                    } else {
                        error();
                    }
                }, error);
            }
        }, error);
    } else {
        sucess();
    }
}
